import "./src/global.css";
import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

// reCAPTCHA Site Key
// CRITICAL: In Gatsby, browser-accessible env vars MUST start with GATSBY_
// In Netlify, add: GATSBY_RECAPTCHA_SITE_KEY (not SITE_KEY)
// The value will be: 6LdijyojAAAAABkOXhqVy6SxbZIsqwh5GdWm6Aaa
const RECAPTCHA_SITE_KEY = process.env.GATSBY_RECAPTCHA_SITE_KEY || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

// Debug: Log which key is being used
if (typeof window !== 'undefined') {
  if (process.env.GATSBY_RECAPTCHA_SITE_KEY) {
    console.log('✅ Using reCAPTCHA key from environment variable');
  } else {
    console.warn('⚠️ reCAPTCHA key not found!');
    console.warn('   Current: process.env.SITE_KEY =', process.env.SITE_KEY);
    console.warn('   Current: process.env.GATSBY_RECAPTCHA_SITE_KEY =', process.env.GATSBY_RECAPTCHA_SITE_KEY);
    console.warn('   Fix: In Netlify, rename SITE_KEY to GATSBY_RECAPTCHA_SITE_KEY');
    console.warn('   Using test key as fallback');
  }
}

export const wrapRootElement = ({ element }) => {
  if (!RECAPTCHA_SITE_KEY) {
    console.error('❌ reCAPTCHA Site Key is missing!');
    return element;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={RECAPTCHA_SITE_KEY}
      language="en"
    >
      {element}
    </GoogleReCaptchaProvider>
  );
};

export const onClientEntry = () => {
  // Widget is already loaded via HTML head injection for immediate display
  // This is just a fallback in case HTML injection didn't work
  if (document.getElementById('convolo-widget')) return;

  const widget_key = '7c6a6bcac05b10edf5393f6166c504d4';
  window.leadCM = { widget_key };

  const em = document.createElement('script');
  em.type = 'text/javascript';
  em.async = true;
  em.id = 'convolo-widget';
  em.src = 'https://app.convolo.ai/js/icallback.js?v=' + Date.now() + '&key=' + widget_key + '&uri=' + encodeURIComponent(window.location.href);

  const s = document.getElementsByTagName('script')[0];
  if (s && s.parentNode) {
    s.parentNode.insertBefore(em, s);
  } else {
    document.head.appendChild(em);
  }
};

const EXCLUDED_PREFIXES = ["/business-setup-in-ajman-mainland", "/business-setup-in-fujairah-mainland", "/business-setup-in-ras-al-khaimah-mainland", "/business-setup-in-umm-al-quwain-mainland", "/business-setup-in-ajman-offshore", "/business-setup-in-ras-al-khaimah-offshore", "/business-setup-in-ajman-free-zone", "/business-setup-in-fujairah-free-zone", "/business-setup-in-ras-al-khaimah-free-zone", "/business-setup-in-umm-al-quwain-free-zone"];

export const onRouteUpdate = ({ location }) => {
  const shouldHide = EXCLUDED_PREFIXES.some(p =>
    location.pathname.startsWith(p)
  );

  document.body.classList.toggle("hide-convolo", shouldHide);
};
